import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--sidebar"
export default class extends Controller {
	static targets = ["toggler", "sidebar"]

	connect() {
		if (this.hasTogglerTarget) {
			let sidebar = this.sidebarTarget
			this.togglerTarget.addEventListener("click", function (e) {
				e.preventDefault();
				sidebar.classList.toggle("shrink");
				sidebar.classList.toggle("show");
			});
		} else {
			return
		}
	}
}